import styled from "styled-components";

const StyledEmbeddedVideo = styled.iframe`
    border: 5px solid black;
    width: 50vw;
    height: calc(50vw / 1.7);
`

function EmbeddedVideo(){
    return(
        <StyledEmbeddedVideo 
            src="https://www.youtube.com/embed/2i31HJwaDS0" 
            title="Embedded YouTube video" 
            allow="autoplay; picture-in-picture; fullscreen" 
        ></StyledEmbeddedVideo>
    )
}

export default EmbeddedVideo;